export default "__VITE_ASSET__BwUI4Xjj__"